// 吃瓜黑屋 —— 首页展示数据（静态 mock，仅供本站展示）

export interface TickerItem {
  tag: string;
  text: string;
}

export interface StatItem {
  num: string;
  label: string;
}

export interface FeedItem {
  time: string;
  heat: string;
  tag: string;
  title: string;
  excerpt: string;
}

export interface CollectionItem {
  title: string;
  subtitle: string;
  meta: string;
  read: string;
  tag: string;
  image: string;
}

export interface ZoneItem {
  name: string;
  desc: string;
  count: string;
  tone: "ember" | "leaf" | "ink";
  icon: string;
}

export interface EncryptedFeature {
  icon: string;
  title: string;
  desc: string;
}

export interface HiddenPreview {
  label: string;
  text: string;
  level: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const tickerItems: TickerItem[] = [
  { tag: "置顶", text: "吃瓜黑屋内部爆料今晚 21:00 加更，某顶流塌房完整复盘已进入加密专区" },
  { tag: "热", text: "头部直播间数据注水内幕再添新料，独家内幕截图已归档待核" },
  { tag: "新", text: "综艺后期真实剧本流出，私密分享链接 48 小时后过期" },
  { tag: "新", text: "资本圈并购暗局更新第三期，隐藏内容仅对加密专区会员开放" },
];

export const stats: StatItem[] = [
  { num: "2.4w+", label: "今日新增瓜料" },
  { num: "860+", label: "归档深度专题" },
  { num: "97%", label: "素材溯源已验证" },
  { num: "24/7", label: "私密素材持续更新" },
];

export const feedItems: FeedItem[] = [
  {
    time: "08:40",
    heat: "38.2w 围观",
    tag: "一线速报",
    title: "某顶流行程被连续打点，幕后跟拍团队连夜改线",
    excerpt: "内部爆料称，近三日公开行程与私拍地点高度重合，团队已启动紧急排查，矛头疑似指向身边工作人员。",
  },
  {
    time: "昨天",
    heat: "61.5w 围观",
    tag: "商务拆解",
    title: "直播间「砍价」话术被拆穿，所谓工厂价其实翻了三倍",
    excerpt: "独家内幕还原一套固定的『原价虚标、再砍到心理价』流程，同款商品三个时段报价差异显著。",
  },
  {
    time: "昨天",
    heat: "27.9w 围观",
    tag: "综艺内幕",
    title: "艺人『人设崩塌』桥段其实有十页脚本文档",
    excerpt: "一档热播综艺的后期脚本流出，多个『高光时刻』来自二次剪辑与现场调度，并非即兴发挥。",
  },
  {
    time: "周一",
    heat: "44.7w 围观",
    tag: "圈内关系",
    title: "两座『友谊牌坊』同日被拆，经纪人通话记录露马脚",
    excerpt: "曾被反复营销的圈内好姐妹，私密分享的文件显示商务报价互相抬价，翻脸早有预兆。",
  },
  {
    time: "周日",
    heat: "19.3w 围观",
    tag: "财经瓜",
    title: "一笔过桥资金辗转三家壳公司，最终流向某新消费品牌",
    excerpt: "吃瓜黑屋内部爆料追溯资金轨迹，背后操盘人与连续两轮融资的出品方存在交叉任职。",
  },
];

export const collections: CollectionItem[] = [
  {
    title: "塌房全复盘",
    subtitle: "从爆红到失控的完整时间线",
    meta: "9 篇深度专题 · 持续更新",
    read: "约 38 分钟",
    tag: "顶流档案",
    image: "https://readdy.ai/api/search-image?query=scattered%20torn%20confidential%20documents%20and%20newspaper%20clippings%20with%20red%20stamp%20marks%20pinned%20on%20a%20dark%20wooden%20investigation%20board%20in%20a%20dim%20room%20dramatic%20overhead%20warm%20amber%20light%20deep%20shadows%20secret%20leak%20archive%20aesthetic%20editorial%20noir%20high%20contrast%20film%20grain%20muted%20matte%20texture%20no%20text%20no%20watermark&width=720&height=880&seq=heigua-col-01&orientation=portrait",
  },
  {
    title: "综艺幕后",
    subtitle: "剪辑台背后的真实剧本",
    meta: "12 篇独家内幕 · 持续更新",
    read: "约 45 分钟",
    tag: "圈内拆解",
    image: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20dark%20television%20studio%20at%20night%20with%20silhouettes%20of%20staff%20around%20a%20glowing%20editing%20monitor%20warm%20amber%20screen%20light%20deep%20black%20shadows%20mysterious%20industry%20insider%20atmosphere%20editorial%20noir%20cinematic%20film%20grain%20no%20text%20no%20watermark&width=720&height=880&seq=heigua-col-02&orientation=portrait",
  },
  {
    title: "带货水分实验室",
    subtitle: "一场直播到底能虚报多少",
    meta: "7 篇专题合集 · 持续更新",
    read: "约 25 分钟",
    tag: "商务透视",
    image: "https://readdy.ai/api/search-image?query=a%20dim%20e%20commerce%20livestream%20studio%20with%20a%20glowing%20ring%20light%20and%20stacked%20cardboard%20boxes%20in%20shadow%20an%20empty%20presenter%20chair%20warm%20amber%20glow%20against%20charcoal%20black%20background%20mysterious%20commercial%20secrets%20editorial%20noir%20high%20contrast%20film%20grain%20no%20text%20no%20watermark&width=720&height=880&seq=heigua-col-03&orientation=portrait",
  },
  {
    title: "公关战内幕",
    subtitle: "热搜背后的那台黑色电话",
    meta: "6 篇内部爆料 · 持续更新",
    read: "约 20 分钟",
    tag: "关系拆解",
    image: "https://readdy.ai/api/search-image?query=a%20black%20vintage%20rotary%20telephone%20on%20a%20dark%20wooden%20desk%20with%20warm%20lamp%20glow%20and%20scattered%20business%20cards%20and%20a%20closed%20folder%20deep%20shadows%20secretive%20public%20relations%20war%20atmosphere%20editorial%20noir%20cinematic%20film%20grain%20no%20text%20no%20watermark&width=720&height=880&seq=heigua-col-04&orientation=portrait",
  },
  {
    title: "品牌翻车档案",
    subtitle: "一份爆款是如何从神坛跌落的",
    meta: "10 篇专题合集 · 持续更新",
    read: "约 50 分钟",
    tag: "商业观察",
    image: "https://readdy.ai/api/search-image?query=dark%20archival%20storage%20shelves%20with%20wrapped%20mystery%20cardboard%20files%20and%20boxes%20in%20a%20dim%20warehouse%20lit%20by%20a%20single%20warm%20beam%20from%20above%20dust%20in%20light%20editorial%20noir%20archival%20investigation%20aesthetic%20deep%20charcoal%20shadows%20no%20text%20no%20watermark&width=720&height=880&seq=heigua-col-05&orientation=portrait",
  },
  {
    title: "资本暗线",
    subtitle: "壳公司背后到底是谁",
    meta: "8 篇独家内幕 · 持续更新",
    read: "约 32 分钟",
    tag: "财经瓜",
    image: "https://readdy.ai/api/search-image?query=low%20angle%20view%20of%20dark%20glass%20skyscrapers%20at%20night%20with%20sparse%20warm%20window%20lights%20under%20a%20heavy%20sky%20silhouettes%20of%20towers%20a%20moody%20corporate%20intrigue%20skyline%20editorial%20noir%20cinematic%20film%20grain%20no%20text%20no%20watermark&width=720&height=880&seq=heigua-col-06&orientation=portrait",
  },
];

export const zones: ZoneItem[] = [
  { name: "内娱速递", desc: "热搜之外的明星动态与行程预警，第一时间抵达现场。", count: "2,318 条", tone: "ember", icon: "ri-flashlight-line" },
  { name: "综艺拆解台", desc: "逐帧还原剪辑与剧本，看镜头背后的真实意图。", count: "1,204 条", tone: "ink", icon: "ri-clapperboard-line" },
  { name: "商务水分实验室", desc: "扒开报价单与坑位费，看清带货的真实成色。", count: "863 条", tone: "leaf", icon: "ri-price-tag-3-line" },
  { name: "圈内关系网", desc: "谁和谁早已决裂，谁又在同一张饭桌上。", count: "1,076 条", tone: "ember", icon: "ri-git-branch-line" },
  { name: "资本暗线", desc: "追资金、查壳公司，把幕后操盘手拽出水面。", count: "642 条", tone: "ink", icon: "ri-focus-3-line" },
  { name: "品牌翻车档案", desc: "记录每一场盛极而衰，复盘翻车全周期。", count: "921 条", tone: "leaf", icon: "ri-archive-drawer-line" },
  { name: "公关战前线", desc: "热搜撤稿、水军调度，公关桌上的攻防实录。", count: "517 条", tone: "ember", icon: "ri-shield-flash-line" },
  { name: "内幕长文库", desc: "万字深度档案，只给真正愿意读完的人。", count: "386 条", tone: "ink", icon: "ri-file-text-line" },
  { name: "私密分享区", desc: "读者投稿与加密素材，私密分享仅供会员翻阅。", count: "保密", tone: "leaf", icon: "ri-lock-2-line" },
];

export const encryptedFeatures: EncryptedFeature[] = [
  { icon: "ri-eye-off-line", title: "隐藏内容解锁", desc: "全网无法公开检索的深度素材，全部折叠在加密专区内逐条归档。" },
  { icon: "ri-timer-flash-line", title: "提前 48 小时", desc: "重大瓜料先发会员，私密分享链接同步内测，普通页只会滞后同步。" },
  { icon: "ri-folder-shield-line", title: "素材三重校验", desc: "独家内幕须过溯源、交叉、风险三道闸，拒绝未经证实的二道转述。" },
  { icon: "ri-shield-keyhole-line", title: "阅后即焚体验", desc: "关键截图设置时效水印，私密分享不保存、不转发、不留痕。" },
];

export const hiddenPreviews: HiddenPreview[] = [
  { label: "本期内幕 · 人设篇", text: "某顶流团队内部备忘录：何时立人设、何时演翻车，均有排期表与应急口径……", level: "会员 · 阅后即焚" },
  { label: "本期内幕 · 商务篇", text: "三家带货机构共享的「报价水位表」流出，同一商品不同账号开价相差悬殊……", level: "会员 · 隐藏内容" },
  { label: "本期内幕 · 资本篇", text: "一笔并购对赌的补充协议被拍下，触发条件是股价连续三十日低于某一阈值……", level: "私密分享 · 限时" },
];

export const faqs: FaqItem[] = [
  {
    q: "吃瓜黑屋的内容都是真实的第一手爆料吗？",
    a: "本站坚持『内部爆料 + 独家内幕』双通道来源。每一条上线前都经过溯源、交叉比对与风险三道校验，可公开部分在普通页展示，需保护来源或未完整定性的素材会折叠进加密专区。",
  },
  {
    q: "加密专区和普通页面有什么区别？",
    a: "加密专区存放普通页无法公开的隐藏内容与私密分享素材，包括长文完整版、敏感截图与持续更新的深度专题。专区内容不进入检索，只对已开启权限的读者开放。",
  },
  {
    q: "私密分享的内容会过期吗？",
    a: "会。为保护原始信源，部分私密分享素材设有阅读时效与水印，超时自动归档或销毁，防止二次泄露。站内所有加密入口均做了提示，请按需及时阅读。",
  },
  {
    q: "内容会删帖或维护『某方』吗？",
    a: "吃瓜黑屋只做记录与归档，不做删帖生意，也不收钱控评。涉及风险与争议的条目，我们选择加密而非消失，让素材保留证据价值，这也是本站对外立场的底色。",
  },
  {
    q: "如何投稿或参与私密分享？",
    a: "普通读者可在站内对应分区提交线索，专区会员可直接上传匿名素材。所有投稿经校验后按安全等级决定是否公开或进入加密专区，投稿人身份全程匿名。",
  },
  {
    q: "涉及真人争议会不会有风险？",
    a: "本站对仍在定性的内容采用化名或代号，完整素材仅存加密专区并设置时限。同时保留对来源的完整留证，配合必要的合规审查，尽最大努力在爆料与责任之间取得平衡。",
  },
];

export const footerColumns: { title: string; links: string[] }[] = [
  { title: "栏目导航", links: ["内娱速递", "综艺拆解台", "商务水分实验室", "圈内关系网", "资本暗线"] },
  { title: "加密专区", links: ["会员说明", "私密分享协议", "素材提交", "隐藏内容目录", "阅后即焚规则"] },
  { title: "关于黑屋", links: ["站长手记", "内容立场", "信源保护承诺", "投稿合作", "意见反馈"] },
];